export default "__VITE_ASSET__29cf6080__"